import Image from "next/image";
import phone from "../../assets/images/upsc/phone.png";
import styles from "../upsc-prestorming-prelims-test-series/prestorming.module.css";
import NewiconA from "../../assets/images/header/pdf-download1.png";
import Link from "next/link";
const Prelims = () => {

     const feestructure3 =[

          {center: "Salem",mode: (<><div>Batch 2 - Regular</div><div>(Online & Offline)</div></>), start: "10th Oct 2026",
          cont3:(<Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/prestorming-2026/Salem/Prestorming-B2-2026-27-Salem.pdf" target="_blank" className={`${styles.paybill}`}> 
                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/>Download PDF</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=SALEM&coursetype=PRESTORMING" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            }

    ];
 
  return (
    <>
 <section  id="courseandfees">
    <div className="container pt-xl-4" >
      <div className="row">
         <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Center</div>
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Batch</div>
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Starts on</div>
         <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Schedule</div> 
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Admission</div>
           <hr/>
      </div>
                    
      {feestructure3.map((item,index)=>(
        <div className={`${styles.facultyborder3} row`}>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-3`}>{item.center}</div>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3  pb-md-3`}>{item.mode}</div>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.start}</div>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                 <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-2`}>{item.cont3}</div> 
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Admission</div>
                 <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-2`}>
          {item.pay}
        </div>
          <hr/>
        </div>
      ))} 
     
    </div>
   
</section>  

<div className="container pt-2 pb-2">
  <p className={`${styles.acheiverrank1} pt-3 pb-2`}><span style={{color:"#e21111ff"}}>Note :</span> Prestorming Batch 1- 7th Sep (Only Annanagar)<sup className= {`${styles.dot1}`}>*</sup></p>
</div>

 {/* <!-- Salem Fee Section --> */}
 
<div className="container py-3">
        <div className="row">
          <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
            <div className={`${styles.facultyborder3} p-4 h-100`}>
              <p className={`${styles.sectionsubtitle}`}>GS + CSAT</p>
              <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>9,500/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
                </div>
              </div>
              <div className="row pt-3">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>8,500/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
            <div className={`${styles.facultyborder3} p-4 h-100`}>
              <p className={`${styles.sectionsubtitle}`}>GS</p>
              <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>9,000/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
                </div>
              </div>
              <div className="row pt-3">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>8,000/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
            <div className={`${styles.facultyborder3} p-4 h-100`}>
              <p className={`${styles.sectionsubtitle}`}>CSAT</p>
              <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>1,500/-</p>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>1,500/-</p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
</div> 

<div className="container py-2">
          <div className="row">
              <div className="col-lg-6 col-12">
              <div className={`${styles.prebg}`}>
                 <h2 className={`${styles.aboutheading1}`}>Salem Venue</h2>
                 <p className={`${styles.acheiverrank1} ${styles.dark} mb-0`}><Image src={phone} alt="Shankar IAS Academy annanagar contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel:0427-2441961" className={`${styles.numberbold}`}>0427-2441961</a> <b>,</b> <a href="tel:89400 80039" className={`${styles.numberbold}`} >89400 80039</a></p>
                 <p className={`${styles.acheiverrank1} mb-0`}>No.207/5 United Arcade, Kauveri Avenue,</p>
                 <p className={`${styles.acheiverrank1} mb-0`}>State Bank Colony, Junction Main Road,</p>
                 <p className={`${styles.acheiverrank1} `}>Salem – 636 004</p>
                 <p className={`${styles.redunderline} `}><Link href="https://www.google.com/maps/place/Shankar+IAS+Academy+Salem/@11.6759226,78.1267411,17z/data=!4m2!3m1!1s0x3babf06604aaffff:0x2db44c2f425bdcb8?hl=en" rel="noreferrer" target="_blank" className={`${styles.redunderlinealink}`}>Get Direction</Link></p>
              </div>
            </div>
          </div>
</div>

</>
);
};

export default Prelims;